import emailIcon from '../assets/email.svg';
import gmailIcon from '../assets/gmail.svg';
import telegramIcon from '../assets/telegram.svg';
import whatsappIcon from '../assets/whatsapp.svg';
import smsIcon from '../assets/imessage.svg';
import slackIcon from '../assets/slack.svg';
import holdedIcon from '../assets/holded.png';
import prezoIcon from '../assets/prezo.png';
import odooIcon from '../assets/odoo.png';
import tSpoonLabIcon from '../assets/tspoonlab.png';
import stripeIcon from '../assets/stripe.svg';
import accountIcon from '../assets/icon-account.svg';
import investmentIcon from '../assets/icon-investment.svg';
import cardIcon from '../assets/icon-card.svg';
import loanIcon from '../assets/icon-loan.svg';
import genericProductIcon from '../assets/icon-generic.svg';
import color from 'color';

const INTEGRATION_ICON_MAP = {
    email: emailIcon,
    gmail: gmailIcon,
    telegram: telegramIcon,
    whatsapp: whatsappIcon,
    sms: smsIcon,
    slack: slackIcon,
    holded: holdedIcon,
    odoo: odooIcon,
    tspoonlab: tSpoonLabIcon,
    prezo: prezoIcon,
    stripe: stripeIcon,
};

export function mapDtoToIntegration(dto) {
    return {
        ...dto,
        creation_date: new Date(dto.creation_date),
        last_execution: dto.last_execution ? new Date(dto.last_execution) : null,
        next_execution: dto.next_execution ? new Date(dto.next_execution) : null,
        is_deleted_datetime: dto.is_deleted_datetime ? new Date(dto.is_deleted_datetime) : null,
        icon: INTEGRATION_ICON_MAP[dto.service] || emailIcon,
        help_description: dto.address ?? '-',
    };
}

const getProductIcon = (product) => {
    switch (product.type) {
        case 'checking':
            return accountIcon;
        case 'investment':
        case 'pensionplan':
        case 'stocks':
        case 'securities':
        case 'saving':
            return investmentIcon;
        case 'card':
        case 'debit':
            return cardIcon;
        case 'loan':
        case 'lineofcredit':
            return loanIcon;
        default:
            return genericProductIcon;
    }
};

export function mapDtoToProduct(dto) {
    return {
        ...dto,
        icon: getProductIcon(dto),
        creation_date: new Date(dto.creation_date),
    };
}

export function mapDtoToAutomation(dto) {
    return {
        ...dto,
        creation_date: new Date(dto.creation_date),
        last_scheduled: new Date(dto.last_scheduled),
        last_sent: dto.last_sent ? new Date(dto.last_sent) : null,
    };
}

export function mapDtoToAlert(dto) {
    return {
        ...dto,
        creation_date: new Date(dto.creation_date),
        last_scheduled: new Date(dto.last_scheduled),
        last_sent: dto.last_sent ? new Date(dto.last_sent) : null,
    };
}

export function sortItems(a, b) {
    if (a.is_premium_blocked && !b.is_premium_blocked) return 1;
    if (!a.is_premium_blocked && b.is_premium_blocked) return -1;

    return a.order - b.order;
}

export function mapDtoToCategory(dto) {
    return {
        ...dto,
        color: `#${dto.color}`,
        bgColor: color(`#${dto.color}`).alpha(0.15).rgb().string(),
        creation_date: new Date(dto.creation_date),
        categorization_keywords: dto.categorization_keywords ?? [],
    };
}
